'use strict';

wbApp.controller('FranchiseAttendanceSummaryCtrl', ['$scope', 'franchiseSvc', 'tenantInfo',
function ($scope, franchiseSvc, tenantInfo) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();
    $scope.franchiseCentralID = tenantInfo.franchiseCentrals.length
        ? tenantInfo.franchiseCentrals[0].tenantID
        : null;

    $scope.onSeachCriteriaChanged = function () {
        $scope.attendanceSummary = franchiseSvc.getAttendanceSummaryForFranchiseCentral($scope.franchiseCentralID, $scope.fromDate, $scope.toDate);
    }

    $scope.attendanceSummary = franchiseSvc.getAttendanceSummaryForFranchiseCentral($scope.franchiseCentralID, $scope.fromDate, $scope.toDate);

    $scope.gridOptions = {
        sortInfo: { fields: ['tenantName'], directions: ['dsc'] },
        noCommandColumn: true,
        columnDefs: [
            { field: 'franchiseSubjectName', displayName: "TXT_LBL_SUBJECT", sort: 'locale' },
            { field: 'employeeFullName', displayName: "TXT_LBL_EMPLOYEE", sort: 'locale', width: "200px" },
            { field: 'noOFCredits', displayName: "TXT_LBL_NO_OF_CREDITS", width: "120px", align: 'right' }
        ]
    };
}]);